import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { createAccount, editAccount } from './form.thunks';
import { ApiError } from '../../services/api';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export interface AccountFormState {
  loading: boolean;
  error: string | null | ApiError;
}

export const initialState: AccountFormState = {
  error: null,
  loading: false
};

const getAccountForm = (state: RootState): AccountFormState => state.accounts.form;

export const selectors = {
  getAccountForm
};

export const extraReducers = {
  [createAccount.pending.type]: (state: AccountFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [createAccount.fulfilled.type]: (state: AccountFormState): void => {
    state.loading = false;
  },
  [createAccount.rejected.type]: (state: AccountFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [editAccount.pending.type]: (state: AccountFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [editAccount.fulfilled.type]: (state: AccountFormState): void => {
    state.loading = false;
  },
  [editAccount.rejected.type]: (state: AccountFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    resetCreateAccountError: (state: AccountFormState): AccountFormState => {
      if (!isFeatureEnabled(Features.PlgExternal3)) {
        return state;
      }

      state.error = null;
      return state;
    }
  },
  extraReducers
});

export default formSlice.reducer;

export const actions = formSlice.actions;
export const caseReducers = formSlice.caseReducers;
